import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import './styles.css'
import Dropdown from "../Dropdown";
import { useMainContext } from "../../../contexts/MainContext";
import { useCatalogsContext } from "../../../contexts/CatalogsContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faPlusCircle, faTrash } from '@fortawesome/free-solid-svg-icons';


const ModalAddMasterItem = (props) => {
    let mainContext = useMainContext();
    let catalogs = useCatalogsContext();
    const { showModal, setShow, mode = "create", handlerAccept, dataImport } = props
    const [formData, setFormData] = useState({})
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [filteredInitiatives, setFilteredInitiatives] = useState([]);
    const [showImportLog, setShowImportLog] = useState(false);


    const isEditMode = mode === "edit";

    const modalTitle = isEditMode ? "Editar Master Item" : "Nuevo Master Item";
    const mainButtonLabel = isEditMode ? "Guardar Cambios" : "Agregar";


    const hardcodedInitiatives = [
        { id: 1, name: "La Nacional" },
        { id: 2, name: "Costalina" },
        { id: 3, name: "Naos" },
        { id: 4, name: "La Colina" },
        { id: 5, name: "Alana" },
        { id: 6, name: "Danna" },
        { id: 7, name: "Santarena" },
        { id: 8, name: "Lorena" },
    ];

    useEffect(() => {
        if (!searchText.trim()) {
            setFilteredInitiatives([]);
            return;
        }

        const results = hardcodedInitiatives.filter(item =>
            item.name.toLowerCase().includes(searchText.toLowerCase())
        );

        setFilteredInitiatives(results);
    }, [searchText]);


    /**
        * Cierra el modal.
    */
    const handleClose = () => {
        setFormData({})
        setShow(false);
    }

    /**
        * Comfirmacion de borrado.
    */
    useEffect(() => {
        setFormData({})

    }, [showModal, dataImport])

    // Tabla dinámica
    const [options, setOptions] = useState([
        { id: 1, name: "Opción 1", description: "" },
        { id: 2, name: "Opción 2", description: "" },
        { id: 3, name: "Opción 3", description: "" },
        { id: 4, name: "Opción 4", description: "" },
        { id: 5, name: "Opción 5", description: "" },
        { id: 6, name: "Opción 6", description: "" },
        { id: 7, name: "Opción 7", description: "" },
        { id: 8, name: "Opción 8", description: "" },
    ]);



    const updateField = (id, field, value) => {
        setOptions(options.map(o =>
            o.id === id ? { ...o, [field]: value } : o
        ));
    };

    return (
        <section>
            <Modal
                className="cardMasterItem"
                size={"xl"}
                show={showModal}
                onHide={handleClose}
                backdrop="static"
                centered
            >
                <div className="custom-card">
                    <div className="custom-card-header px-3 d-flex justify-content-between align-items-center">
                        <h4 className="py-3">{modalTitle}</h4>
                    </div>

                    <div className="content-filters">
                        <div id="contentSearchBar">
                            <label><b>Nombre del Master Item</b></label>
                            <div id="search">
                                <button type="submit" id="searchButton">
                                    <span className="iconSearch">
                                        <FontAwesomeIcon icon={faSearch} />
                                    </span>
                                </button>
                                <input type="text" id="inputSearch" placeholder="Nombre" />
                            </div>
                        </div>

                        <div className="select-filter">
                            <label><b>Tipo de pregunta</b></label>
                            <Dropdown optionLabel="typeQuestion" optionValue="typeID" />
                        </div>

                        <div className="select-filter">
                            <label><b>Tipo de Valor</b></label>
                            <Dropdown optionLabel="typeValue" optionValue="valueID" />
                        </div>
                    </div>
                    <div className="containerButtonAdd">
                        <button className="add-button">
                            <FontAwesomeIcon icon={faPlusCircle} />
                        </button>
                    </div>
                    <div className="table-container">
                        <table className="options-table">
                            <thead>
                                <tr>
                                    <th>Orden</th>
                                    <th>Opción</th>
                                    <th>Descripción</th>
                                    <th>Eliminar</th>
                                </tr>
                            </thead>

                            <tbody>
                                {options.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.id}</td>
                                        <td>
                                            <input
                                                type="text"
                                                value={item.name}
                                                onChange={(e) => updateField(item.id, "name", e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                value={item.description}
                                                onChange={(e) => updateField(item.id, "description", e.target.value)}
                                            />
                                        </td>
                                        <td className="delete-cell">
                                            <FontAwesomeIcon
                                                icon={faTrash}
                                                className="delete-icon" />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="container d-flex containerButtons">
                        {isEditMode && (
                            <div className="">
                                <button className="btn btn-primary ml-3">
                                    Eliminar Master Item
                                </button>
                            </div>
                        )}
                        <div>
                            <button className="btn btn-white" onClick={handleClose}>
                                Cancelar
                            </button>
                            <button
                                className="btn btn-primary ml-3"
                                onClick={() => setShowImportLog(true)}
                            >
                                {mainButtonLabel}
                            </button>
                        </div>
                    </div>

                </div>
            </Modal>
        </section>
    );

}
export default ModalAddMasterItem